import React from "react";
import { Helmet } from "react-helmet";
import { EmbeddableMarkup } from "./shortcodes-map";

export interface HTMLEmbedProps extends EmbeddableMarkup {
  cbKey: string;
}

const HTMLEmbed: React.FC<HTMLEmbedProps> = ({
  externalScriptSources,
  scripts,
  html,
  cbKey,
}) => (
  <div key={cbKey}>
    {externalScriptSources && (
      <Helmet>
        {externalScriptSources.map((src) => (
          <script
            key={src}
            async
            src={src}
            type="text/javascript"
            charSet="utf-8"
          />
        ))}
        {scripts &&
          scripts.map((script) => (
            <script type="text/javascript" charSet="utf-8">
              {script}
            </script>
          ))}
      </Helmet>
    )}
    <div dangerouslySetInnerHTML={{ __html: html }} />
  </div>
);

export { HTMLEmbed };
